<template>
  <div class="locationNote-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加红包规则</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           :title="title"
           @on-ok="createlocationNote('locationNoteValidate')"
           :loading="loading"
           :mask-closable="false">
      <Form :model="locationNote"
            ref="locationNoteValidate"
            :rules="locationNoteValidate"
            action="javascript:void(0)"
            :label-width="80">
        <FormItem label="选择类型"
                  prop="note_id">
          <Select v-model="locationNote.note_id"
                  placeholder="类型..."
                  @on-change="notetype">
            <Option v-for="item in typeList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="红包说明"
                  prop="sort">
          <Input v-model="locationNote.title"
                 placeholder="不超过255字符"></Input>
        </FormItem>
        <FormItem label="有效期"
                  prop="sort">
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      :value="datePic"
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="起始 - 截止"></DatePicker>
        </FormItem>
        <!-- <FormItem label="封面图"
                  prop="thumb">
          <upload-thumb v-model="locationNote.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="686"
                        :autoCropHeight="284"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"></upload-thumb>
        </FormItem> -->
        <FormItem label="数量"
                  prop="sort">
          <Input v-model="locationNote.nums"
                 placeholder="发送的红包数量"></Input>
        </FormItem>
        <FormItem label="金额"
                  :style="{display:showMoney?'block':'none'}">
          <Row>
            <Col span="8">
            满:
            <InputNumber v-model="locationNote.full"></InputNumber>
            </Col>
            <Col span="8">
            减：
            <InputNumber v-model="locationNote.money"></InputNumber>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="折扣"
                  :style="{display:showRebate?'block':'none'}">
          <Input v-model="locationNote.rebate"
                 placeholder="折扣"></Input>
        </FormItem>
        <FormItem label="现金"
                  :style="{display:showCash?'block':'none'}">
          <Input v-model="locationNote.cash"
                 placeholder="现金"></Input>
        </FormItem>
        <FormItem label="选择平台"
                  prop="sort"
                  :style="{display:showSelect?'block':'none'}">
          <Row>
            <Col span="8">
            <Checkbox v-model="single"
                      style="margin-left:10px ">全平台</Checkbox>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="项目定位点"
                  prop="display"
                  :style="{display:showSelect?'block':'none'}">
          <Table border
                 :columns="columns"
                 ref="selection"
                 :data="tablelist1"
                 :loading="dataloading"></Table>
          <Button @click="showLocationModel()"
                  type="success"
                  long
                  style="margin-top:5px;">请选择匠人定位点</Button>
        </FormItem>
      </Form>
    </Modal>
    <!--定位点-->
    <Modal v-model="showLocationModalStatus"
           title="项目定位点"
           @on-ok="setPoint">
      <Form :model="search_s"
            ref="search_s"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="search_s.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable1('search_s')">查找</Button>
        </FormItem>
      </Form>
      <RadioGroup v-model="ptdw"
                  vertical
                  @on-change="changeDw">
        <Radio v-for="(item,key) in tablelist2"
               :label="item.id">{{item.title}}</Radio>
      </RadioGroup>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page ref="listPage1"
                :total="pages1.total"
                :current="pages1.page"
                :page-size="pages1.size"
                show-elevator
                show-total
                @on-change="changePage1()"></Page>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
export default {
  name: "locationNote-list",
  data () {
    return {
      datePic: [],
      single: true,
      showSelect: false,
      loading1: false,
      loading: true,
      dataloading: true,
      thumblist: [],
      tablelist2: [],
      tablelist1: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      pages1: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: ""
      },
      bigDisplay: "",
      columns: [
        {
          title: "定位点名称",
          key: "ptname"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          fixed: "right",
          width: '90px',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      // this.remove(params.index, params.row.id);
                      this.locationNote.location_id = 0;
                      this.locationNote.ptname = null;
                      this.tablelist1 = [];
                      // this.showSelect = true;
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "类型",
          key: "noteName",
          width: 100
        },
        {
          title: "标题",
          key: "title",
          minWidth: 200
        },
        // {
        //   title: "定位点",
        //   key: "name",
        //   minWidth: 200,
        //   render: (h, params) => {
        //     var s = "";
        //     if (params.row.location != null) s = params.row.location.title;
        //     if (params.row.location_id == 0) s = "全平台";
        //     return h("div", [h("span", {}, s)]);
        //   }
        // },
        {
          title: "时效",
          key: "name",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#8a6d3b"
                  }
                },
                "起始：" + params.row.begin_at
              ),
              h(
                "p",
                {
                  style: {
                    color: "#777"
                  }
                },
                "截止：" + params.row.end_at
              )
            ]);
          }
        },
        {
          title: "剩余量",
          key: "nums",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "p",
                {
                  style: {
                    color: "#337ab7"
                  }
                },
                params.row.nums + "个"
              ),
              h(
                "p",
                {
                  style: {
                    color: "#a9444"
                  }
                },
                "￥" + params.row.money
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      locationNote: {
        location_id: 0,  // 0 全平台 非零选的定位点
        ptname: "",
        status: true
      },
      showModalStatus: false,
      showLocationModalStatus: false,
      showMoney: false,
      showRebate: false,
      showCash: false,
      locationNoteValidate: {
        // note_id: [
        //     { required: true, message: '名称必须填写', trigger: 'blur' }
        // ],
      },
      typeList: [],
      locationList: [],
      search_s: {
        key: ""
      },
      params: {
        datetime: [],
        datetimeTwo: ""
      },
      ptdw: null // 定位点
    };
  },

  created: function () {
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb
  },
  methods: {
    // 切换红包类型
    notetype: function (val) {
      // 返回的是 lable值
      if (val == "1" || val == "4") {
        this.showMoney = true;
        this.showRebate = false;
        this.showCash = false;
      } else if (val == "2") {
        this.showMoney = false;
        this.showRebate = false;
        this.showCash = true;
      } else if (val == "3") {
        this.showMoney = false;
        this.showRebate = true;
        this.showCash = false;
      }
    },
    getTableList: function () {
      this.$api.locationNote
        .list({ page: this.pages.page, size: this.pages.size })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.typeList = res.result.typeList;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // choseAllPlatForm (value) {
    //   if (value === true) {
    //     this.locationNote.location_id = 0;
    //     this.locationNote.ptname = null;
    //     this.tablelist1 = [];
    //     this.showSelect = false;
    //   } else {
    //     this.locationNote.location_id = 0;
    //     this.locationNote.ptname = null;
    //     this.tablelist1 = [];
    //     this.showSelect = true;
    //   }
    //   return;
    // },
    // 翻页
    changePage1 () {
      this.pages1.page = this.$refs["listPage1"].currentPage;
      this.renderTable1(1);
    },
    renderTable1 (value) {
      this.loading1 = true;
      var ps = {
        key: this.search_s.key,
        page: this.pages1.page,
        size: this.pages1.size
      };
      this.$api.locationNote.locations(ps).then(res => {
        if (res.code == 200) {
          this.tablelist2 = res.result.list;
          this.pages1.total = res.result.total;
        }
        this.loading1 = false;
      });
      return;
    },
    //选中提交
    setPoint () {
      console.log('this.locationNote.location_idthis.locationNote.location_id,', this.locationNote.location_id)
      // this.selected = this.$refs.selection.getSelection();
      this.tablelist1 = [this.locationNote];
    },
    remoteMethod2 (id) {
      this.loading1 = true;
      this.$api.intangibleLocation
        .allLocations({ page: 1, size: 999999, id: id })
        .then(res => {
          if (res.code == 200) {
            this.locationList = res.result;
            this.$forceUpdate();
          }
          this.loading1 = false;
        });
      return;
    },
    //展开定位点
    showLocationModel () {
      this.showLocationModalStatus = !this.showLocationModalStatus;
      this.renderTable1(1);
    },
    // 展开添加
    showModel () {
      this.title = "添加红包规则";
      this.locationNote = {
        id: null,
        location_id: 0,
        ptname: ""
      };
      this.tablelist1 = [];
      this.notetype(2);
      this.thumblist = new Array();
      this.$refs["locationNoteValidate"].resetFields();
      this.datePic = new Array();
      this.params.datetime = new Array();
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index, id) {
      this.title = "编辑规则";
      this.locationNote = {
        name: ""
      };
      this.thumblist = new Array();
      this.$refs["locationNoteValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
      this.$api.locationNote.detail({ id: id }).then(res => {
        this.locationNote = res.result;
        this.notetype(this.locationNote.note_id);
        if (this.locationNote.location_id == 0) {
          this.single = true;
          this.showSelect = false;
        } else {
          this.single = false;
          this.showSelect = true;
          // var that= this;
          // setTimeout(function(){
          //     that.remoteMethod2(that.locationNote.location_id);
          // },0);
        }
        this.datePic = [this.locationNote.begin_at, this.locationNote.end_at];
        this.params.datetime = [
          this.locationNote.begin_at,
          this.locationNote.end_at
        ];
        if (this.locationNote.thumb != null && this.locationNote.thumb != "") {
          this.thumblist.push({
            name: this.locationNote.thumb,
            url: this.locationNote.thumb,
            status: "finished"
          });
        }
        if (this.locationNote.note_id == 2) {
          this.locationNote.cash = this.locationNote.money;
        }
      });
    },
    // 添加
    createlocationNote (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"] && this.$refs["uploadthumb"].uploadList.length > 0) {
            this.locationNote.thumb = this.$refs[
              "uploadthumb"
            ].uploadList[0].url;
          }
          this.locationNote.begin_at =
            this.params.datetime[0] != undefined ? this.params.datetime[0] : "";
          this.locationNote.end_at =
            this.params.datetime[1] != undefined ? this.params.datetime[1] : "";

          if (this.locationNote.id == null || this.locationNote.id == 0) {
            this.$api.locationNote.create(this.locationNote).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = !this.showModalStatus;
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          } else {
            console.log(1155);
            this.$api.locationNote.edit(this.locationNote).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = !this.showModalStatus;
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    changeDate (val) {
      this.params.datetime = val;
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.locationNote.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.tablelist.splice(index, 1);
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.locationNote.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 选择定位
    changeDw (e) {
      console.log(e)
      this.locationNote.location_id = e;
      console.log('this.locationNote.location_id', this.locationNote.location_id)
      console.log(this.ptdw)
      for (var i = 0; i < this.tablelist2.length; i++) {
        if (this.tablelist2[i].id == e) {
          this.locationNote.ptname = this.tablelist2[i].title;
        }
      }
    }
  }
};
</script>
